var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCalendarIcon = function SvgCalendarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 3.733V2.8c0-.518-.445-.933-1-.933h-1V.933C12 .416 11.555 0 11 0c-.555 0-1 .416-1 .933v.934H4V.933C4 .416 3.555 0 3 0c-.555 0-1 .416-1 .933v.934H1c-.555 0-1 .415-1 .933v.933h14zM13 14c.555 0 1-.416 1-.933v-8.4H0v8.4C0 13.584.445 14 1 14h12zm-1-5.6h-2V6.533h2V8.4zm-8 0H2V6.533h2V8.4zm4 0H6V6.533h2V8.4zm4 3.733h-2v-1.866h2v1.866zm-8 0H2v-1.866h2v1.866zm4 0H6v-1.866h2v1.866z"
  })));
};
export default SvgCalendarIcon;